<script>
	import firebase_ from 'firebase/app';
	import 'firebase/auth';
	
	export default {
		name: 'EmailLinkExecuter',
		methods: {
			sendEmailLink() {
				const self_ = this;

				const actionCodeSettings_ = {
					// This must be true.
					handleCodeInApp: true,

					url: self_.firebaseUrl,
					dynamicLinkDomain: self_.firebaseDynamicLinkDomain
				}

				const email_ = window.localStorage.getItem('emailForAuth')

				if (self_.isFalse(email_)) { return }

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return firebase_.auth().sendSignInLinkToEmail(email_, actionCodeSettings_)
					}).then(() => {
						resolve()
					}).catch(error => {
						let error_
						if(self_.isFalse(error)) {
							error_ = 'Error: signUpByEmail(' + email_ + ') -> promise';
						} else { error_ = error }
						reject(error_)
					})
				})
			},
			verifyEmailLink() {
				const self_ = this;
				
				const mode_ = window.localStorage.getItem('modeOfAuth')

				if(mode_ == 'signUp') { self_.$_elExec_verifyEmailLinkSignUp() }
				if(mode_ == 'forgetPassword') { self_.$_elExec_verifyEmailLinkResetPassword() }
			},
			$_elExec_verifyEmailLinkSignUp(){
				const self_ = this;
				const router_ = self_.$router;

				const email_ = window.localStorage.getItem('emailForAuth')
				const password_ = window.localStorage.getItem('passwordForAuth')

				if (self_.isFalse(email_) || self_.isFalse(password_)) { return }

				const user_ = {
					username: email_,
					email: email_,
					fullName: email_,
					password: password_
				}

				Promise.resolve().then(() => {
					return self_.registerUser(user_)
				}).then(() => {
					window.localStorage.removeItem('modeOfAuth')
					window.localStorage.removeItem('emailForAuth')
					window.localStorage.removeItem('passwordForAuth')

					router_.replace('/login')
				}).catch(error => {
/* error */			self_.logError('Error', '$_elExec_verifyEmailLinkSignUp()', error)
				})
			},
			$_elExec_verifyEmailLinkResetPassword(){
				const self_ = this;
				const router_ = self_.$router;

				const email_ = window.localStorage.getItem('emailForAuth')

				if (self_.isFalse(email_)) { return }

				Promise.resolve().then(() => {
					return self_.firebase.auth().signInWithEmailLink(email_, window.location.href)
				}).then(() => {
					window.localStorage.removeItem('modeOfAuth')
					window.localStorage.removeItem('emailForAuth')

					router_.replace('/reset-password')
				}).catch(error => {
/* error */			self_.logError('Error', '$_elExec_verifyEmailLinkResetPassword()', error)
				})
			}
		}
	}
</script>